import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap";
export default class extends Controller {
  connect() {
    this.initializeTooltips()
  }

  disconnect() {
    this.destroyTooltips()
  }

  initializeTooltips() {
    const tooltipTriggerList = [].slice.call(this.element.querySelectorAll('[data-bs-toggle="tooltip"]'))
    this.tooltips = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  }

  destroyTooltips() {
    if (this.tooltips) {
      this.tooltips.forEach(tooltip => tooltip.dispose())
    }
  }
}
